<template>
  <div id="DefaultLayout">
    <DefaultNavbar />
    <router-view />
    <DefaultFooter />
  </div>
</template>


<script>
// @ is an alias to /src
import DefaultFooter from "@/components/DefaultFooter.vue";
import DefaultNavbar from "@/components/DefaultNavbar.vue";

export default {
  name: "Home",
  components: {
    DefaultFooter,
    DefaultNavbar
  }
};
</script>
